import React from 'react';
import { Container, Typography, Box, Grid, TextField, Button } from '@mui/material';
import { motion } from 'framer-motion';
import Layout from './Layout';
import { colors } from '../colors';

const ContactUsPage = () => {
    return (
        <Layout>
            {/* Blue Banner */}
            <Box
                sx={{
                    backgroundColor: colors.primaryBannerBlue,
                    color: 'white',
                    padding: { xs: '5px 0', sm: '10px 0' }, // Responsive padding
                    textAlign: 'center',
                    fontSize: { xs: '1rem', sm: '1.2rem' },
                    fontWeight: '500',
                }}
            >
                CONTACT US
            </Box>
            <Container maxWidth="md" sx={{ mt: 5 }}>
                {/* Hero Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.5 }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #F8C7C3, #F4D8C2)',  // Dark blue header background
                            color: 'white',
                            padding: '50px 20px',
                            textAlign: 'center',
                            borderRadius: '10px',
                            boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',  // Soft shadow effect
                        }}
                    >
                        <Typography variant="h3"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',  // Bold text for the title
                                letterSpacing: '1px',  // Slightly spaced letters for a more elegant feel
                                color: colors.racineRedDark,  // Coral red for the title to stay within your theme
                            }}
                        >
                            Get in Touch
                        </Typography>
                        <Typography variant="h6"
                            sx={{
                                color: colors.primaryApplicationText,  // Coral red for the title to stay within your theme
                            }}
                        >
                            We'd love to hear from you! Whether you have a question about our services, need assistance, or just want to provide feedback, feel free to reach out.
                        </Typography>
                    </Box>
                </motion.div>

                {/* Contact Form */}
                <motion.div
                    initial={{ x: '-100vw' }}
                    animate={{ x: 0 }}
                    transition={{ type: 'spring', stiffness: 120 }}
                >
                    <Box mt={8}>
                        <Typography variant="h4" gutterBottom>
                            Contact Us
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Full Name"
                                    variant="outlined"
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Message"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} textAlign="center">
                                <Button
                                    variant="contained"
                                    sx={{ backgroundColor: colors.racineRedDark, color: 'white', padding: '10px 30px' }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </motion.div>

                {/* Additional Contact Information */}
                <Box textAlign="center" mt={10} mb={5}>
                    <Typography variant="h5" gutterBottom>
                        You can also reach us at:
                    </Typography>
                    <Typography variant="body1">
                        Email: jan@racinereview.org
                    </Typography>
                </Box>
            </Container>
        </Layout>
    );
};

export default ContactUsPage;
